import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { LoaderComponent } from './loader/loader.component';
import { PaginationComponent } from './pagination/pagination.component';
import { SliderDialogContainerComponent } from './slider-dialog-container/slider-dialog-container.component';
import { PortalModule } from '@angular/cdk/portal';
import { OverlayModule } from '@angular/cdk/overlay';
import { SliderDialogService } from './services/slider-dialog.service';
import { TrackDetailsService } from './services/track-details.service';
import { SessionStorageService } from './services/session-storage.service';
import { BpmService } from './services/bpm.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TrackPreviewComponent } from './track-preview/track-preview.component';
import { EditTrackComponent } from './edit-track/edit-track.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSliderModule } from '@angular/material/slider';
import {MatPaginatorModule} from '@angular/material/paginator';
import { TrackStatusComponent } from './track-status/track-status.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatRadioModule } from '@angular/material/radio';
import { TrackDetailsComponent } from './track-details/track-details.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PlayerService } from './services/player.service';
import { ImportService } from './services/import.service';
import { PartnerService } from './services/partner.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { ChipsComponentComponent } from './chips-component/chips-component.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { ManageCowritersComponent } from './manage-cowriters/manage-cowriters.component';
import { TrackDescriptionComponent } from './track-description/track-description.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { EditTrackVersionComponent } from './edit-track-version/edit-track-version.component';
import { TrackDetailsForVersionComponent } from './track-details-for-version/track-details-for-version.component';
import { TrackListComponent } from './track-list/track-list.component';
import { PlaylistTrackListComponent } from './playlist-track-list/playlist-track-list.component';
import { MusicplayerComponent } from './musicplayer/musicplayer.component';
import { WaveformComponent } from './waveform/waveform.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { DurationPipe } from './pipes/duration.pipe';
import { TrackStatusPipe } from './pipes/trackstatus.pipe';
import { FiltersComponent } from './filters/filters.component';
import { TrackInfoComponent } from './trackinfo/trackinfo.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { RangeDatepickerComponent } from './range-datepicker/range-datepicker.component';
import { ExportOptionsDialogComponent } from './export-options-dialog/export-options-dialog.component';
import { DownloadResultsDialogComponent } from './download-results-dialog/download-results-dialog.component';
import { CSRFInterceptor } from './interceptors/csrf.interceptor';
import { NewPlaylistFolderDialogComponent } from './new-playlist-folder-dialog/new-playlist-folder-dialog.component';
import { DuplicatePlaylistDialogComponent } from './duplicate-playlist-dialog/duplicate-playlist-dialog.component';
import { AddRemovePlaylistDialogComponent } from './add-remove-playlist-dialog/add-remove-playlist-dialog.component';
import { DeletePlaylistDialogComponent } from './delete-playlist-dialog/delete-playlist-dialog.component';
import { RemoveTrackDialogComponent } from './remove-track-dialog/remove-track-dialog.component';
import { ManageTracksClientsDialogComponent } from './manage-tracks-clients-dialog/manage-tracks-clients-dialog.component';
import { AddSongPlaylistDialogComponent } from './add-song-playlist-dialog/add-song-playlist-dialog.component';
import { SelectBackdropClassDirective } from '../select-backdrop-class.directive';
import { UserClientListComponent } from './user-client-list/user-client-list.component';
import { UserArtistListComponent } from './user-artist-list/user-artist-list.component';
import { AddToEmailGroupComponent } from './add-to-email-group/add-to-email-group.component';
import { ManageUserPlaylistsComponent } from './manage-user-playlists/manage-user-playlists.component';
import { ClientActivityDialogComponent } from './client-activity-dialog/client-activity-dialog.component';
import { ManageClientAccountComponent } from './manage-client-account/manage-client-account.component';
import { DeleteClientDialogComponent } from './delete-client-dialog/delete-client-dialog.component';
import { ArtistActivityDialogComponent } from './artist-activity-dialog/artist-activity-dialog.component';
import { ManageArtistAccountComponent } from './manage-artist-account/manage-artist-account.component';
import { CountrySelectComponent } from './country-select/country-select.component';
import { SelectSearchComponent } from './select-search/select-search.component';
import { SelectItemComponent } from './select-search/select-item/select-item.component';
import { StateSelectComponent } from './state-select/state-select.component';
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { DeleteTrackVersionDialogComponent } from './delete-track-version-dialog/delete-track-version-dialog.component';
import { BpmFieldComponent } from './bpm-field/bpm-field.component';
import { UserEmailGroupListComponent } from './user-email-group-list/user-email-group-list.component';
import { NewUserEmailGroupComponent } from './new-user-email-group/new-user-email-group.component';
import { DeleteUserEmailGroupComponent } from './delete-user-email-group/delete-user-email-group.component';
import { RemoveUsersFromEmailGroupComponent } from './remove-users-from-email-group/remove-users-from-email-group.component';
import { NewEmailTemplateDialogComponent } from './new-email-template-dialog/new-email-template-dialog.component';
import { CampaignSendDialogComponent } from './campaign-send-dialog/campaign-send-dialog.component';
import { CampaignStatusBarComponent } from './campaign-status-bar/campaign-status-bar.component';
import { DeleteEmailTemplateDialogComponent } from './delete-email-template-dialog/delete-email-template-dialog.component';
import { DeletePlaylistFoldersDialogComponent } from './delete-playlist-folders-dialog/delete-playlist-folders-dialog.component';
import { UserDialogueFormComponent } from './user-dialogue-form/user-dialogue-form.component';
import { MenuConfigService } from './services/menu-config.service';
import { UserMenuService } from './services/user-menu.service';
import { MenuListService } from './services/menu-list.service';
import { UserService } from './services/user.service';
import { ComposerListService } from './services/composer-list.service';
import { CreateTrackComponent } from './create-track/create-track.component';
import { ComposerTrackDescriptionComponent } from './composer-track-description/composer-track-description.component';
import { CreateTrackVersionComponent } from './create-track-version/create-track-version.component';
import { NgWaveformModule } from 'ng-waveform';
import { WaveformWaveComponent } from './waveform-wave/waveform-wave.component';
import { MinuteSecondsPipe, PreviewWaveformComponent } from './preview-waveform/preview-waveform.component';
import { ComposerManageCowritersComponent } from './composer-manage-cowriters/composer-manage-cowriters.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AddTrackPlaylistDialogComponent } from './add-track-playlist-dialog/add-track-playlist-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DuplicatetemplatePopupComponent } from './duplicatetemplate-popup/duplicatetemplate-popup.component';
import { UserUploadPopupComponent } from './user-upload-popup/user-upload-popup.component';
import { EditNewTrackComponent } from './edit-new-track/edit-new-track.component';
import { NewTrackDescriptionComponent } from './new-track-description/new-track-description.component';
import { TrackNewDetailComponent } from './track-new-detail/track-new-detail.component';
import { EditNewTrackVersionComponent } from './edit-new-track-version/edit-new-track-version.component';
import { TrackVersionNewDetailComponent } from './track-version-new-detail/track-version-new-detail.component';
import { TrackNewListComponent } from './track-new-list/track-new-list.component';
import { SupportComponent } from './support/support.component';
import { NewMusicplayerComponent } from './new-musicplayer/new-musicplayer.component';
import { AngularWavesurferServiceModule } from 'angular-wavesurfer-service';
import { ComposerNewVersionDescriptionComponent } from './composer-new-version-description/composer-new-version-description.component';
import { MatSelectFilterModule } from 'mat-select-filter';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LySliderModule } from '@alyle/ui/slider';
import { DataSideNavComponent } from './data_components/_sidenav/data-side-nav/data-side-nav.component';
import { DataDashboardComponent } from './data_components/data-dashboard/data-dashboard.component';
import { ProSelectHeaderComponent } from './data_components/_headers/pro-select-header/pro-select-header.component';
import { DataProComponent } from './data_components/_pro_tab_views/data-pro/data-pro.component';
import { ProImportComponent } from './data_components/_pro_tab_views/pro-import/pro-import.component';
import { ProImportMapSubmitHeaderComponent } from './data_components/_headers/pro-import-map-submit-header/pro-import-map-submit-header.component';
import { SuperAdminProImportComponent } from './data_components/_pro_tab_views/super-admin-pro-import/super-admin-pro-import.component';
import { SuperAdminProMapLabelsComponent } from './data_components/_pro_tab_views/super-admin-pro-map-labels/super-admin-pro-map-labels.component';
import { PartnerGroupShowMapperComponent } from './data_components/_pro_tab_views/partner-group-show-mapper/partner-group-show-mapper.component';
import { ReadyToMapComponent } from './data_components/_pro_tab_views/ready-to-map/ready-to-map.component';
import { RightArrowIconComponent } from './_svgs/right-arrow-icon/right-arrow-icon.component';
import { BulletIconComponent } from './_svgs/bullet-icon/bullet-icon.component';
import { UploadIconComponent } from './_svgs/upload-icon/upload-icon.component';
import { DeleteIconComponent } from './_svgs/delete-icon/delete-icon.component';
import { DataPartnerComponent } from './data_components/_partner_tab_views/data-partner/data-partner.component';
import { PartnerSelectHeaderComponent } from './data_components/_headers/partner-select-header/partner-select-header.component';
import { PartnerManagementComponent } from './data_components/_partner_tab_views/partner-management/partner-management.component';
import { PartnerGroupManagementComponent } from './data_components/_partner_tab_views/partner-group-management/partner-group-management.component';
import { PlusIconComponent } from './_svgs/plus-icon/plus-icon.component';
import { StatusDotIconComponent } from './_svgs/status-dot-icon/status-dot-icon.component';
import { DropDownArrowComponent } from './_svgs/drop-down-arrow/drop-down-arrow.component';
import { SortArrowsIconComponent } from './_svgs/sort-arrows-icon/sort-arrows-icon.component';
import { AddPartnerModalComponent } from './data_components/_modals/add-partner-modal/add-partner-modal.component';
import { CloseXIconComponent } from './_svgs/close-xicon/close-xicon.component';
import { SnackBarService } from './services/snack-bar.service';
import { AddPartnerGroupModalComponent } from './data_components/_modals/add-partner-group-modal/add-partner-group-modal.component';
import { AddPartnerToGroupModalComponent } from './data_components/_modals/add-partner-to-group-modal/add-partner-to-group-modal.component';
import { GrabIconComponent } from './_svgs/grab-icon/grab-icon.component';
import { PartnerDetailHeaderComponent } from './data_components/_headers/partner-detail-header/partner-detail-header.component';
import { PartnerDetailNavHeaderComponent } from './data_components/_headers/partner-detail-nav-header/partner-detail-nav-header.component';
import { PartnerDetailsComponent } from './data_components/_partner_tab_views/partner-details/partner-details.component';
import { PartnersListComponent } from './data_components/_partner_tab_views/partners-list/partners-list.component';
import { ProPartnerDetailsComponent } from './data_components/_partner_tab_views/pro-partner-details/pro-partner-details.component';
import { ProPartnerShowsComponent } from './data_components/_partner_tab_views/pro-partner-shows/pro-partner-shows.component';
import { PartnerDisplayContentComponent } from './data_components/_partner_tab_views/partner-display-content/partner-display-content.component';
import { PartnerDetailProHeaderComponent } from './data_components/_headers/partner-detail-pro-header/partner-detail-pro-header.component';
import { PartnerDetailProContentComponent } from './data_components/_partner_tab_views/partner-detail-pro-content/partner-detail-pro-content.component';
import { FilterPanelIconComponent } from './_svgs/filter-panel-icon/filter-panel-icon.component';
import { ApproveProsModalComponent } from './data_components/_modals/approve-pros-modal/approve-pros-modal.component';
import { ExportProModalComponent } from './data_components/_modals/export-pro-modal/export-pro-modal.component';
import { MoveArrowIconComponent } from './_svgs/move-arrow-icon/move-arrow-icon.component';
import { ProPartnerShowContentComponent } from './data_components/_partner_tab_views/pro-partner-show-content/pro-partner-show-content.component';
import { ProPartnerShowHeaderComponent } from './data_components/_headers/pro-partner-show-header/pro-partner-show-header.component';
import { InformationIconComponent } from './_svgs/information-icon/information-icon.component';
import { MapAllShowsErrorModalComponent } from './data_components/_modals/map-all-shows-error-modal/map-all-shows-error-modal.component';
import { StopSignIconComponent } from './_svgs/stop-sign-icon/stop-sign-icon.component';
import { ImportingSelectionsModalComponent } from './data_components/_modals/importing-selections-modal/importing-selections-modal.component';
import { TreeStructureIconComponent } from './_svgs/tree-structure-icon/tree-structure-icon.component';
import { ProArchiveComponent } from './data_components/_pro_tab_views/pro-archive/pro-archive.component';
import { ProArchiveContentComponent } from './data_components/_pro_tab_views/pro-archive-content/pro-archive-content.component';
import { ProArchiveHeaderComponent } from './data_components/_headers/pro-archive-header/pro-archive-header.component';
import { ProDataFilterModalComponent } from './data_components/_modals/pro-data-filter-modal/pro-data-filter-modal.component';
import { CreateDataSetModalComponent } from './data_components/_modals/create-data-set-modal/create-data-set-modal.component';
import { AddShowsModalComponent } from './data_components/_modals/add-shows-modal/add-shows-modal.component';
import { MoveShowModalComponent } from './data_components/_modals/move-show-modal/move-show-modal.component';
import { MoveShowToPartnerGroupModalComponent } from './data_components/_modals/move-show-to-partner-group-modal/move-show-to-partner-group-modal.component';
import { PartnerGroupToolTipModalComponent } from './data_components/_modals/partner-group-tool-tip-modal/partner-group-tool-tip-modal.component';
import { ModalTopNotchComponent } from './_svgs/modal-top-notch/modal-top-notch.component';
import { MatSelectBottomScrollDirective } from './data_components/_directives/mat-select-bottom-scroll.directive';
import { MatSelectTypingDirective } from './data_components/_directives/mat-select-typing.directive';
import { EditDataSetModalComponent } from './data_components/_modals/edit-data-set-modal/edit-data-set-modal.component';
import { CustomScrollBarComponent } from './data_components/_custom-tools/custom-scroll-bar/custom-scroll-bar.component';
import { CustomPaginationComponent } from './data_components/_custom-tools/custom-pagination/custom-pagination.component';
import { EpisodeMapperModalComponent } from './data_components/_modals/episode-mapper-modal/episode-mapper-modal.component';
import { AddPostDilutorModalComponent } from './data_components/_modals/add-post-dilutor-modal/add-post-dilutor-modal.component';
import { DataManagementComponent } from './data_components/_management_tab_views/data-management/data-management.component';
import { DataManagementShowModalComponent } from './data_components/_modals/data-management-show-modal/data-management-show-modal.component';
import { DataManagementCreateShowModalComponent } from './data_components/_modals/data-management-create-show-modal/data-management-create-show-modal.component';
import { DataManagementCreateSeasonModalComponent } from './data_components/_modals/data-management-create-season-modal/data-management-create-season-modal.component';
import { DataManagementCreateEpisodeModalComponent } from './data_components/_modals/data-management-create-episode-modal/data-management-create-episode-modal.component';
import { DataManagementCreateEpisodeInfoModalComponent } from './data_components/_modals/data-management-create-episode-info-modal/data-management-create-episode-info-modal.component';
import { ProImportDetailsTableComponent } from './data_components/_pro_tab_views/pro-import-details-table/pro-import-details-table.component';
import { DataManagementUpdateShowModalComponent } from './data_components/_modals/data-management-update-show-modal/data-management-update-show-modal.component';
import { ShowMapperTableComponent } from './data_components/data-pro-new/show-mapper-table/show-mapper-table.component';
import { ShowMapperModalComponent } from './data_components/_modals/show-mapper-modal/show-mapper-modal.component';
import { ImportManagementComponent } from './data_components/_management_tab_views/import-management/import-management.component';
import { PartnerGroupMapperTableComponent } from './data_components/data-pro-new/partner-group-mapper-table/partner-group-mapper-table.component';
import { MapProToPartnerGroupModalComponent } from './data_components/_modals/map-pro-to-partner-group-modal/map-pro-to-partner-group-modal.component';
import { AlternateTitlesModalComponent } from './data_components/_modals/alternate-titles-modal/alternate-titles-modal.component';
import { DeleteImportModalComponent } from './data_components/_modals/delete-import-modal/delete-import-modal/delete-import-modal.component';
import { LoaderComponent as OverlayLoaderComponent } from './overlays/loader/loader.component';
import { LoaderDirective as OverlayLoaderDirective } from './overlays/loader/loader.directive';

// import { DataTablesModule } from "angular-datatables";

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    DeleteImportModalComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    SliderDialogContainerComponent,
    TrackPreviewComponent,
    EditTrackComponent,
    TrackStatusComponent,
    TrackDetailsComponent,
    ChipsComponentComponent,
    ManageCowritersComponent,
    TrackDescriptionComponent,
    MinuteSecondsPipe,
    EditTrackVersionComponent,
    TrackDetailsForVersionComponent,
    PaginationComponent,
    TrackListComponent,
    PlaylistTrackListComponent,
    TrackNewListComponent,
    MusicplayerComponent,
    NewMusicplayerComponent,
    WaveformComponent,
    DurationPipe,
    TrackStatusPipe,
    FiltersComponent,
    TrackInfoComponent,
    RangeDatepickerComponent,
    ExportOptionsDialogComponent,
    DownloadResultsDialogComponent,
    NewPlaylistFolderDialogComponent,
    DuplicatePlaylistDialogComponent,
    AddRemovePlaylistDialogComponent,
    DeletePlaylistDialogComponent,
    RemoveTrackDialogComponent,
    ManageTracksClientsDialogComponent,
    AddSongPlaylistDialogComponent,
    SelectBackdropClassDirective,
    UserClientListComponent,
    UserArtistListComponent,
    AddToEmailGroupComponent,
    ManageUserPlaylistsComponent,
    ClientActivityDialogComponent,
    ManageClientAccountComponent,
    DeleteClientDialogComponent,
    ArtistActivityDialogComponent,
    ManageArtistAccountComponent,
    CountrySelectComponent,
    SelectSearchComponent,
    SelectItemComponent,
    StateSelectComponent,
    PhoneMaskDirective,
    DeleteTrackVersionDialogComponent,
    BpmFieldComponent,
    UserEmailGroupListComponent,
    NewUserEmailGroupComponent,
    DeleteUserEmailGroupComponent,
    RemoveUsersFromEmailGroupComponent,
    NewEmailTemplateDialogComponent,
    CampaignSendDialogComponent,
    CampaignStatusBarComponent,
    DeleteEmailTemplateDialogComponent,
    DeletePlaylistFoldersDialogComponent,
    UserDialogueFormComponent,
    CreateTrackComponent,
    ComposerTrackDescriptionComponent,
    CreateTrackVersionComponent,
    WaveformWaveComponent,
    PreviewWaveformComponent,
    ComposerManageCowritersComponent,
    AddTrackPlaylistDialogComponent,
    DuplicatetemplatePopupComponent,
    UserUploadPopupComponent,
    EditNewTrackComponent,
    NewTrackDescriptionComponent,
    TrackNewDetailComponent,
    EditNewTrackVersionComponent,
    TrackVersionNewDetailComponent,
    SupportComponent,
    ComposerNewVersionDescriptionComponent,
    DataSideNavComponent,
    DataDashboardComponent,
    ProSelectHeaderComponent,
    DataProComponent,
    ProImportComponent,
    ProImportMapSubmitHeaderComponent,
    SuperAdminProImportComponent,
    SuperAdminProMapLabelsComponent,
    PartnerGroupShowMapperComponent,
    ReadyToMapComponent,
    RightArrowIconComponent,
    BulletIconComponent,
    UploadIconComponent,
    DeleteIconComponent,
    DataPartnerComponent,
    PartnerSelectHeaderComponent,
    PartnerManagementComponent,
    PartnerGroupManagementComponent,
    PlusIconComponent,
    StatusDotIconComponent,
    DropDownArrowComponent,
    SortArrowsIconComponent,
    AddPartnerModalComponent,
    CloseXIconComponent,
    AddPartnerGroupModalComponent,
    AddPartnerToGroupModalComponent,
    GrabIconComponent,
    PartnerDetailHeaderComponent,
    PartnerDetailNavHeaderComponent,
    PartnerDetailsComponent,
    PartnersListComponent,
    ProPartnerDetailsComponent,
    ProPartnerShowsComponent,
    PartnerDisplayContentComponent,
    PartnerDetailProHeaderComponent,
    PartnerDetailProContentComponent,
    FilterPanelIconComponent,
    ApproveProsModalComponent,
    ExportProModalComponent,
    MoveArrowIconComponent,
    ProPartnerShowContentComponent,
    ProPartnerShowHeaderComponent,
    InformationIconComponent,
    MapAllShowsErrorModalComponent,
    StopSignIconComponent,
    ImportingSelectionsModalComponent,
    TreeStructureIconComponent,
    ProArchiveComponent,
    ProArchiveContentComponent,
    ProArchiveHeaderComponent,
    ProDataFilterModalComponent,
    CreateDataSetModalComponent,
    AddShowsModalComponent,
    MoveShowModalComponent,
    MoveShowToPartnerGroupModalComponent,
    PartnerGroupToolTipModalComponent,
    ModalTopNotchComponent,
    MatSelectBottomScrollDirective,
    MatSelectTypingDirective,
    EditDataSetModalComponent,
    CustomScrollBarComponent,
    CustomPaginationComponent,
    EpisodeMapperModalComponent,
    AddPostDilutorModalComponent,
    DataManagementComponent,
    DataManagementShowModalComponent,
    DataManagementCreateShowModalComponent,
    DataManagementCreateSeasonModalComponent,
    DataManagementCreateEpisodeModalComponent,
    DataManagementCreateEpisodeInfoModalComponent,
    ProImportDetailsTableComponent,
    DataManagementUpdateShowModalComponent,
    ShowMapperTableComponent,
    ShowMapperModalComponent,
    ImportManagementComponent,
    PartnerGroupMapperTableComponent,
    MapProToPartnerGroupModalComponent,
    AlternateTitlesModalComponent,
    DeleteImportModalComponent,
    OverlayLoaderComponent,
    OverlayLoaderDirective
  ],
  exports: [
    HeaderComponent,
    DataSideNavComponent,
    FooterComponent,
    LoaderComponent,
    MatMenuModule,
    PaginationComponent,
    TrackListComponent,
    PlaylistTrackListComponent,
    TrackNewListComponent,
    MusicplayerComponent,
    NewMusicplayerComponent,
    WaveformComponent,
    WaveformWaveComponent,
    FiltersComponent,
    TrackInfoComponent,
    RangeDatepickerComponent,
    UserClientListComponent,
    UserArtistListComponent,
    UserEmailGroupListComponent,
    ManageClientAccountComponent,
    UserDialogueFormComponent,
    PhoneMaskDirective,
    StateSelectComponent,
    CountrySelectComponent,
    SelectSearchComponent,
    SelectItemComponent,
    ClipboardModule,
    MatSnackBarModule,
    DurationPipe,
    AngularWavesurferServiceModule,
    CampaignStatusBarComponent

  ],
  imports: [
    CommonModule,
    PortalModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSliderModule,
    MatPaginatorModule,
    MatCardModule,
    MatOptionModule,
    MatSelectModule,
    MatCheckboxModule,
    MatDividerModule,
    MatRadioModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatExpansionModule,
    MatButtonModule,
    RouterModule,
    MatMenuModule,
    HttpClientModule,
    NgxMatSelectSearchModule,
    MatProgressBarModule,
    MatTableModule,
    MatSortModule,
    MatTooltipModule,
    DragDropModule,
    CdkTableModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatDatepickerModule,
    MatNativeDateModule,
    OverlayModule,
    MatDialogModule,
    AngularWavesurferServiceModule,
    NgxMaskModule.forRoot(maskConfig),
    NgWaveformModule,
    ClipboardModule,
    ImageCropperModule,
    MatSelectFilterModule,
    CKEditorModule,
    LyImageCropperModule,
    LySliderModule,
    LyButtonModule,
    LyIconModule,
    // DataTablesModule
  ],
  providers: [
    SliderDialogService,
    PlayerService,
    MenuConfigService,
    UserMenuService,
    MenuListService,
    UserService,
    ComposerListService,
    SessionStorageService,
    BpmService,
    TrackDetailsService,
    ImportService,
    PartnerService,
    SnackBarService

    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: CSRFInterceptor,
    //   multi: true
    // }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SharedModule { }
